module.exports = __webpack_public_path__ + "static/media/x.d65abc57.svg";